import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { take, map } from 'lodash';

import moment from 'moment';
import { Typography, EnhancedTable } from 'embeds/components';

const columnData = [
  { id: 'patient.name', label: 'Patient Name', padding: 'checkbox', style: { width: 75 } },
  { id: 'patient.dateOfBirth', label: 'Patient DOB', padding: 'checkbox', style: { width: 50 } },
  { id: 'facilityName', label: 'Facility Name', padding: 'checkbox', style: { width: 50 } },
  { id: 'referringProvider', label: 'Referring Provider', padding: 'checkbox', style: { width: 75 } },
];

const styles = (theme) => ({
  title: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1.5,
    fontWeight: 'bold',
  },
  root: {
    flex: 1,
    overflow: 'auto',
    paddingTop: `${theme.spacing.unit * 2 - 1}px`,
    background: theme.palette.common.white,
  },
});

const reformatPatientDateOfBirth = (referrals) =>
  map(referrals, (referral) => {
    let {
      patient: { dateOfBirth },
    } = referral;
    const dobType = typeof dateOfBirth;

    if (dobType === 'object') {
      const { year, month, day } = dateOfBirth;
      dateOfBirth = `${month}/${day}/${year}`;

      // eslint-disable-next-line
      referral.patient.dateOfBirth = moment(dateOfBirth).format('MM/DD/YYYY');
    }

    return referral;
  });

class ReferralsTable extends React.PureComponent {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {this.renderTitle()}
        {this.renderTable()}
      </div>
    );
  }

  renderTitle() {
    const { title } = this.props;
    if (!title) {
      return;
    }
    const { classes, maxRows, referrals: length } = this.props;
    let text = `${title}`;
    if (maxRows < length) {
      text += `. Here are the first ${length} results:`;
    }
    return (
      <Typography className={classes.title} gutterBottom>
        {text}
      </Typography>
    );
  }

  renderTable() {
    const { onCheck, onItemSelected, order, orderBy, referrals, referralsSelected, selectable, maxRows } = this.props;
    let data = maxRows ? take(referrals, maxRows) : referrals;
    data = reformatPatientDateOfBirth(data);

    return (
      <EnhancedTable
        data={data}
        itemsSelected={referralsSelected}
        columnData={columnData}
        selectable={selectable}
        onClick={onItemSelected}
        onCheck={onCheck}
        order={order}
        orderBy={orderBy}
        renderActions={this.renderActions}
      />
    );
  }
}

ReferralsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  referrals: PropTypes.array.isRequired,
  maxRows: PropTypes.number,
  onCheck: PropTypes.func,
  onItemSelected: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  referralsSelected: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.bool]),
  selectable: PropTypes.bool,
};

export default withStyles(styles)(ReferralsTable);
